export default __webpack_public_path__ + "static/media/camera-default.561a82b9.svg";